import React from 'react'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
const Puz14 = () => {
    return (
        <div>
               <NavLink to='/category/Puzzels/Puzzel15'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Next page -&gt; </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<NavLink to='/category/Puzzels/Puzzel13'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'70px'}}>&lt;-   Previous page </Button>
</NavLink>
<article class="container">
    <h1 class="title">Strategy for a 2 Player Coin Game</h1>
    
    <div class="text">
        <p><strong><u>Puzzle</u>:</strong> Consider a two-player coin game where each Player A and Player B gets the
            turn one by one. There is a row of even number of coins, and a player on his/her turn can pick a coin from
            any of the two corners of the row. The player that collects coins with more value wins the game. Develop a
            strategy for the player making the first turn i.e, Player A, such that he/she never loses the game.</p>
        <p>Note that the strategy to pick a maximum of two corners may not work. In the following example, the first
            player, Player A loses the game when he/she uses a strategy to pick a maximum of two corners.<br/>
          </p>
        <div>
        <p><strong>Example:</strong></p> <br/>
        <pre class="output">Initial row:  18 20 15 30 10 14 <br/>
    Player A picks 18, now row of coins is <br/>
     <br/>
    After first pick:  20 15 30 10 14 <br/>
    Player B picks 20, now row of coins is <br/>
     <br/>
    After second pick:  15 30 10 14 <br/>
    Player A picks 15, now row of coins is <br/>
     <br/>
    After third pick:  30 10 14 <br/>
    Player B picks 30, now row of coins is <br/>
     <br/>
    After 4th pick:  10 14 <br/>
    Player A picks 14, now row of coins is <br/>
     <br/>
    Last pick:  10  <br/>
    Player B picks 10, game over. <br/>
     <br/>
    The total value collected by Player B is more (20 +  <br/>
    30 + 10) compared to first player (18 + 15 + 14). <br/>
    So the second picker, Player B wins. </pre> <br/></div>
        <p>&nbsp;<br/>
            &nbsp;<br/>
            &nbsp;</p>
            <div class="containers">
        <p><strong><u>Solution</u>:</strong><br/>
            The idea is to count the sum of values of all even coins and odd coins,
            compare the two values. The player that makes the first move can always make sure that the other player is
            never able to choose an even coin if the sum of even coins is higher. Similarly, he/she can make sure that
            the other player is never able to choose an odd coin if the sum of odd coins is higher. So here are the
            steps to a proper algorithm of either winning the game or getting a tie:</p><br/>

        

        <ul >
            <li><strong>Step 1:</strong> Count the sum of all the coins in the even places(2nd, 4th, 6th and so on). Let
                the sum be “EVEN”.</li>
            <li><strong>Step 2:</strong> Count the sum of all the coins in the odd places(1st, 3rd, 5th and so on). Let
                the sum be “ODD”.</li>
            <li><strong>Step 3:</strong> Compare the value of EVEN and ODD and this is how the first player, here Player
                A must begin its selection.<ol >
                    <li>if (EVEN &gt; ODD), start choosing from the right-hand corner and select all the even placed
                        coins.</li>
                    <li>if (EVEN &lt; ODD), start choosing from the left-hand corner and select all the odd placed
                        coins.</li>
                    <li>if (EVEN == ODD), choosing only the odd-placed or only the even placed coins will throw a tie.
                    </li>
                </ol>
            </li>
        </ul>
        <p><strong>Example:</strong> Suppose you are given the following rows of coins:</p>
        <pre>18 20 15 30 10 14</pre>
        <p>Coins at even places: <em>20, 30, 14</em><br/>
            Coins at odd places: <em>18, 15, 10</em><br/>
            These places are
            fixed independent of whether the choice of selection must begin from the left or the right-hand side.</p>
        <p><strong>Step 1:</strong> Sum of all even placed coins = 20 + 30 + 14 = 64<br/>
            <strong>Step 2:</strong> Sum of
            all odd placed coins = 18 + 15 + 10 = 43<br/>
            <strong>Step 3:</strong> Comparing the even and the odd placed
            coins where EVEN &gt; ODD</p>
        <p>Therefore, Player A must start selecting from the right-hand side and choose all the even-placed coins every
            time(here they are 14, 30 and 20). So first picker, Player A picks 14. Now, irrespective of whether the
            second Player B starts selecting from the left-hand side i.e., 18 or from the right-hand side i.e., 20, the
            even placed coins i.e., 14, 30 and 20 are booked for the Player A. Therefore, be any situation arise, the
            first picker Player A will always win the game.</p>
        <p>Here are the illustrations to both the cases of pick by Player B:<br/>
            <strong>Case 1:</strong> When Player B
            starts picking from the left corner.<br/>
        </p>
        <p><strong>Case 2:</strong> When Player B starts picking from the right corner after Player A.<br/>
        </p>
        </div>
    </div>
</article>
        </div>
    )
}

export default Puz14
